import { render, staticRenderFns } from "./TkIntelPolicyDetail.vue?vue&type=template&id=27dce9e8"
import script from "./TkIntelPolicyDetail.vue?vue&type=script&lang=js"
export * from "./TkIntelPolicyDetail.vue?vue&type=script&lang=js"
import style0 from "./TkIntelPolicyDetail.vue?vue&type=style&index=0&id=27dce9e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports